import type { BariPreResumeMdoData } from '@common/validation/customControls/bariPre/bariPreResumeMdo/v1/bariPreResumeMdoSchemaV1';
import { initialConclusieAanvullendData, initialIndicatieVoorVerwijzingData } from '../utils';

export const initialData: BariPreResumeMdoData = {
    ...initialConclusieAanvullendData,
    ...initialIndicatieVoorVerwijzingData,
    hervatten: null,
    toelichting: null,
};
